import React from 'react'

class DisclaimerFr extends React.Component {
  render() {
    return <div>
      <h2>Avis important</h2>

      <h3>Clause de non-responsabilité</h3>

      <p>Les textes et informations figurant sur le site internet de SenLex sont disponibles gratuitement pour l’information du public.</p>

      <p>L’utilisateur ne peut considérer l’information fournie comme un avis juridique.</p>

      <p>La mention ou la non-mention d'un document parlementaire, d'un arrêt, d'un avis ou de tout autre texte ou partie de texte n'implique aucun jugement de valeur de la part de l'auteur.</p>

      <p>Toutes les données figurant sur ce site sont censées être exactes au moment de leur publication, sans toutefois qu'aucune garantie ne puisse être donnée à ce sujet. En d'autres termes, l'utilisateur fait usage de ces informations à ses propres risques. Le contenu du site peut être adapté, modifié ou complété à tout moment, sans annonce ni notification préalable.</p>

      <p>Le Sénat ne peut en aucun cas être tenu responsable par qui que ce soit, directement ou indirectement, de manière particulière ou autre, pour un dommage dû à l'utilisation de ce site ou d'un autre site accessible par un (hyper)lien, en ce compris, sans restriction, toutes les pertes, les interruptions de fonctionnement, les dégâts causés aux programmes ou à d'autres données du système informatique, au matériel, au logiciel, etc. de l'utilisateur.</p>

      <p>La banque de données SenLex corrige les erreurs signalées par les utilisateurs, mais ne répond à aucune question individuelle et ne fournit aucune assistance juridique en ce qui concerne l'identification, l'interprétation ou l'application des informations mises à disposition.</p>
    </div>
  }
}



export default DisclaimerFr;



/** WEBPACK FOOTER **
 ** ./src/modules/helptexts/disclaimer/fr.js
 **/